import {BaseModel} from "./household/BaseModel";

export default class PortfolioAllocator extends BaseModel{
    static entity = 'App\\Models\\PortfolioAllocator';
    static modelKey= 'portfolio-allocators';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            name_category: this.attr(null),
            risk_category: this.number(0),
            total_value: this.number(0),
            allocations: this.attr(null),
            user_id: this.attr(null),
            created_at: this.attr(null),
        }
    }

    static fetchUserPortfolioAllocators(userId) {
        return this.api().get(`users/${userId}/portfolio-allocators`, {
            dataTransformer: ({data}) => {
                return data.data;
            }
        })
    }
}
